import { render, staticRenderFns } from "./ErrorLogs.vue?vue&type=template&id=4481e145&scoped=true&"
import script from "./ErrorLogs.vue?vue&type=script&lang=js&"
export * from "./ErrorLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4481e145",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4481e145')) {
      api.createRecord('4481e145', component.options)
    } else {
      api.reload('4481e145', component.options)
    }
    module.hot.accept("./ErrorLogs.vue?vue&type=template&id=4481e145&scoped=true&", function () {
      api.rerender('4481e145', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/shared/stats/logs/ErrorLogs.vue"
export default component.exports